/**
 * Complete FCM surface stub for PWA.
 * Vite rewrites every `platform/notifications/fcmDeviceToken` import here —
 * native `src/platform/notifications/fcmDeviceToken.ts` is never loaded on web.
 */

export type FcmDeviceTokenOptions = {
  request_permission?: boolean;
  timeout_ms?: number;
};

export const ADMIN_PUSH_CHANNEL_ID = 'admin_fcm';

export type RemoteMessageLike = {
  notification?: { title?: string; body?: string };
  data?: Record<string, unknown>;
};

export function extractFcmDisplayParts(remoteMessage: RemoteMessageLike): {
  title: string;
  body: string;
} {
  const data = remoteMessage?.data ?? {};
  const title =
    remoteMessage?.notification?.title?.trim() ||
    (typeof data.title === 'string' ? data.title.trim() : '') ||
    '';
  const body =
    remoteMessage?.notification?.body?.trim() ||
    (typeof data.body === 'string' ? data.body.trim() : '') ||
    '';
  return { title, body };
}

export async function displayFcmRemoteMessageWithNotifee(
  _remoteMessage: RemoteMessageLike,
): Promise<void> {
  // no-op on web
}

export function registerFcmBackgroundMessageHandler(): void {
  // no-op on web
}

export async function getFcmDeviceTokenForBackend(
  _options: FcmDeviceTokenOptions = {},
): Promise<string> {
  return '';
}

/** Auth paths already send empty device_token on native; keep identical on web. */
export function getFcmDeviceTokenForAuth(): Promise<string> {
  return Promise.resolve('');
}

export function subscribeFcmForegroundNotifications(): () => void {
  return () => {};
}

export function subscribeFcmTokenRefresh(_on_token?: (token: string) => void): () => void {
  return () => {};
}

export default {
  ADMIN_PUSH_CHANNEL_ID,
  extractFcmDisplayParts,
  displayFcmRemoteMessageWithNotifee,
  registerFcmBackgroundMessageHandler,
  getFcmDeviceTokenForBackend,
  getFcmDeviceTokenForAuth,
  subscribeFcmForegroundNotifications,
  subscribeFcmTokenRefresh,
};
